// extracted by mini-css-extract-plugin
module.exports = {"title-modal":"_1zQqSd_hcUWEvcGSGGC3O4","dialog":"_30jMIqpty8b4YAbzXIknvj","headerDeactivate":"_1zi2Jz5PVpQiz7viCV6tWU","headerActivate":"MKbSOw-9jKuAXYBg1Iny8"};